import { NumberFormatter } from 'reduce-precision';

const DIGITS = {
  '۰': '0', '۱': '1', '۲': '2', '۳': '3', '۴': '4',
  '۵': '5', '۶': '6', '۷': '7', '۸': '8', '۹': '9',
  '٠': '0', '١': '1', '٢': '2', '٣': '3', '٤': '4',
  '٥': '5', '٦': '6', '٧': '7', '٨': '8', '٩': '9',
};

const formatterEnHighNumber = new NumberFormatter({
  language: 'en',
  template: 'number',
  precision: 'high',
});

const formatterEnAutoNumber = new NumberFormatter({
  language: 'en',
  template: 'number',
  precision: 'auto',
});

const formatterFaIrtMedium = new NumberFormatter({
  language: 'fa',
  template: 'irt',
  precision: 'medium',
});

const formatterFaIrtAuto = new NumberFormatter({
  language: 'fa',
  template: 'irt',
  precision: 'auto',
});

const formatterEnUsdAuto = new NumberFormatter({
  language: 'en',
  template: 'usd',
  precision: 'auto',
});

const formatterEnPercentAuto = new NumberFormatter({
  language: 'en',
  template: 'percent',
  precision: 'auto',
});

export function normalizeAmount(value) {
  const normalized = String(value ?? '')
    .replace(/[۰-۹٠-٩]/g, (digit) => DIGITS[digit])
    .replace(/[٬,\s]/g, '')
    .replace(/[٫]/g, '.')
    .replace(/[^\d.]/g, '');
  const firstDot = normalized.indexOf('.');
  const clean = firstDot === -1
    ? normalized
    : normalized.slice(0, firstDot + 1) + normalized.slice(firstDot + 1).replace(/\./g, '');
  const number = clean === '' || clean === '.' ? 0 : Number(clean);

  return { text: clean, value: Number.isFinite(number) ? number : 0 };
}

export function formatNumber(value) {
  return formatterEnHighNumber.toString(value);
}

export function formatAuto(value) {
  return formatterEnAutoNumber.toString(value);
}

export function formatIrtMedium(value) {
  return formatterFaIrtMedium.toString(value);
}

export function formatIrtAuto(value) {
  return formatterFaIrtAuto.toString(value);
}

export function formatUsd(value) {
  return formatterEnUsdAuto.toString(value);
}

export function formatPercent(value) {
  return formatterEnPercentAuto.toString(value);
}
